import { Component, Output } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'layout-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent {

    constructor() {}

    ShowRelevant() {
      return !window.location.pathname.includes('Apply-visa');
    }

}



// WEBPACK FOOTER //
// C:/Users/user/Desktop/rohini_india/angular/Srilanka-eta.org.lk/src/app/shared/layout/footer.component.ts